export default "__VITE_ASSET__BQRmCiAL__"